import { parseHtml } from '@healthhub/react-ui';
import type { RadioGroupProps } from 'antd';
import { Radio, Space } from 'antd';
import DOMPurify from 'dompurify';
import type { ReactNode } from 'react';
import { memo } from 'react';


import CustomRadio from '../CustomRadio/CustomRadio';

export interface OptionsType {
  desc?: string;
  isUseHtmlForDesc?: boolean;
  isUseHtmlForLabel?: boolean;
  label: ReactNode | string;
  value: boolean | string;
}

// TODO: shifted from Checkbox, to be ravamped
export interface RadioOptionsType {
  checked?: boolean;
  desc?: string;
  label: React.ReactNode | string;
  value: string;
}

interface CustomRadioOptionProps extends RadioGroupProps {
  descClassName?: string;
  direction?: 'horizontal' | 'vertical';
  options: OptionsType[];
}

const CustomRadioOption = ({
  className,
  descClassName,
  direction = 'vertical',
  options,
  ...restProps
}: CustomRadioOptionProps) => (
  <Radio.Group {...restProps}>
    <Space direction={direction}>
      {options?.map((option) => (
        <CustomRadio className={className} key={`${option.label}-${String(option.value)}`} value={option.value}>
          {option?.isUseHtmlForLabel ? (
            <div>{parseHtml(DOMPurify.sanitize(option.label as Node | string))}</div>
          ) : (
            <>
              {option.label}
              {!!option.desc && !option.isUseHtmlForDesc && <div className={descClassName}>{option.desc}</div>}
              {!!option.desc && !!option.isUseHtmlForDesc && (
                <div className={descClassName}>{parseHtml(option.desc)}</div>
              )}
            </>
          )}
        </CustomRadio>
      ))}
    </Space>
  </Radio.Group>
);

export default memo(CustomRadioOption);
